import React from 'react'

const Register = () => {
  return (
    <div>Register Page</div>
  )
}

export default Register